import { useState, useEffect, useRef } from 'react';

export default function SearchBox({ value, onChange, searching, t, si }) {
  const [local, setLocal] = useState(value || '');
  const timer = useRef(null);

  // Sync external clear
  useEffect(() => { if (!value && local) setLocal(''); }, [value]);

  function handleChange(v) {
    setLocal(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange(v), 200);
  }

  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 0, maxWidth: 400 }}>
        <input
          value={local}
          onChange={e => handleChange(e.target.value)}
          placeholder="Search invoices, vendors, amounts..."
          style={{ ...si, width: '100%', fontSize: 12, padding: '8px 12px', borderRadius: local ? '8px 0 0 8px' : 8 }}
        />
        {local && (
          <button onClick={() => { setLocal(''); onChange(''); }} style={{ background: t.sf, border: `1px solid ${t.bd}`, borderLeft: 'none', borderRadius: '0 8px 8px 0', padding: '8px 10px', cursor: 'pointer', color: t.td, fontSize: 11, fontFamily: "'DM Sans',sans-serif" }}>✕</button>
        )}
      </div>
      {searching && <div style={{ fontSize: 10, color: t.bl, marginTop: 3 }}>Searching all dates</div>}
    </div>
  );
}
